import api from 'api'
import { CustomShiftNotification } from './getCustomShiftNotifications'

export type CreateCustomShiftNotificationParams = {
  shiftId: number
  deliveryHour: number
  message: string
  title?: string
}

export async function createCustomShiftNotification({
  shiftId,
  deliveryHour,
  message,
  title,
}: CreateCustomShiftNotificationParams) {
  const response = await api.post<CustomShiftNotification>(
    `/admin/shift/${shiftId}/custom_notifications`,
    {
      deliveryHour,
      message,
      ...(title !== undefined && title !== '' ? { title } : {}),
    }
  )
  return response.data
}
